import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ModalMobile as Modal } from '@alfalab/core-components-modal/mobile';
import { TextHolder } from '@alfa-bank/site-text-holder';
import { TextMobile } from '@alfa-bank/site-text-v2/mobile';

import { Header as Component } from '../header';
import type { THeaderProps, IHeaderDeps } from '../models';
import styles from '../../../modal/mobile/mobile.css';

export const ModalV2HeaderMobile = createWidget<IHeaderDeps, THeaderProps>({
    Modal,
    Text: TextMobile,
    TextHolder,
    styles,
    titleView: 'xsmall',
})(Component);
